import moment from 'moment-timezone';

export const GetTimeZone = (date) => {
  // let dateString = moment(date).format('ddd, DD MMM YYYY HH:mm:ss');
  let dateString = moment(date).local().format('MMM DD YYYY HH:mm');
  return dateString;
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '';

  const parsedDate = new Date(dateStr);
  if (isNaN(parsedDate)) return '';

  const yyyy = parsedDate.getFullYear();
  const mm = String(parsedDate.getMonth() + 1).padStart(2, '0');

  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  return `${months[+mm - 1]} ${yyyy}`;
};

export const getWorkonDate = (dateObject, type) => {
  const rawText = dateObject?.rawText?.toLowerCase() || '';
  const isCurrent =
    dateObject?.isCurrent ||
    dateObject?.endDate?.toLowerCase()?.includes('present') ||
    rawText?.includes('till date') ||
    rawText?.includes('present') ||
    rawText?.includes('current');

  if (type === 'level1') {
    return {
      startDate: dateObject.startDate,
      endDate: isCurrent ? 'present' : dateObject.endDate,
      isCurrent: isCurrent,
    };
  } else if (type === 'level2') {
    if (!dateObject?.startDate && !dateObject?.endDate) return '';

    const start = dateObject.startDate ? formatDate(dateObject.startDate) : '';
    const end = isCurrent
      ? ' - present'
      : dateObject.endDate
        ? ' - ' + formatDate(dateObject.endDate)
        : '';

    return `${start}${end}`;
  }
};

export function getActiveDaysLabel(dateString) {
  const createdDate = new Date(dateString);
  const now = new Date();
  const diffMs = now - createdDate;
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  return `Active for ${diffDays} day${diffDays !== 1 ? 's' : ''}`;
}
